import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Location } from '@angular/common';

import {
    VehiclesCompleteChecklist,
    VehiclesCompleteChecklisttData,
    VehiclesCompleteStatus
} from '../models/complete-checklist';

import { CompleteCheckListServices } from '../services/complete-checklist.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { BaseServices } from '../../kuba.services';
import { Subscription, Subject, debounceTime } from 'rxjs';
@Component({
    selector: 'app-kuba-vehicles-complete-checklist',
    templateUrl: './kuba-vehicles-complete-checklist.component.html',
    styleUrls: ['./kuba-complete-checklist.component.css'],
    encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class VehiclesCompleteChecklistComponent implements OnInit {
    VehiclesCompleteChecklist: VehiclesCompleteChecklist;
    VehiclesCompleteChecklisttData: VehiclesCompleteChecklisttData[];
    temperaturevalue: SelectItem[];
    featureKey: number;
    showLoader = false;
    private subscriptions: Subscription[] = [];

  checkpointPage = 0;
  MathMin = Math.min;
  checkpointFilter: 'all' | 'unanswered' | 'deviations' = 'all';
  draftSaving = false;
  draftStatus = '';
  private draftVersion = 0;
  private readonly draftChanges = new Subject<void>();
  get checkpoints() { return this.VehiclesCompleteChecklisttData ?? []; }
  get answered(): number { return this.checkpoints.filter(item => item.Status?.some(status => status.Value)).length; }
  get checkpointPages(): number[] { return Array.from({length: Math.ceil(this.checkpoints.length / 10)}, (_, i) => i); }
  get sectionCheckpoints() { return this.checkpoints.length >= 25 ? this.checkpoints.slice(this.checkpointPage * 10, this.checkpointPage * 10 + 10) : this.checkpoints; }
  get visibleCheckpoints() {
    return this.sectionCheckpoints.filter(item => this.checkpointFilter === 'all' ||
      (this.checkpointFilter === 'unanswered' ? !item.Status?.some(status => status.Value) : item.Status?.[2]?.Value));
  }
  firstUnanswered(): void {
    const index = this.checkpoints.findIndex(item => !item.Status?.some(status => status.Value));
    if (index < 0) return;
    this.checkpointPage = Math.floor(index / 10);
    this.checkpointFilter = 'unanswered';
  }
  markRestNa(): void {
    for (const item of this.sectionCheckpoints) {
      if (!item.Status?.some(status => status.Value) && item.Status?.[1]) this.setStatus(item.Status[1], item.Status);
    }
  }
  queueDraft(): void {
    this.draftVersion++;
    this.draftStatus = 'CHECKLIST_REDESIGN.UNSAVED';
    this.draftChanges.next();
  }
  private saveDraft(): void {
    if (this.draftSaving || this.showLoader || !this.VehiclesCompleteChecklist) return;
    const version = this.draftVersion;
    this.draftSaving = true;
    this.draftStatus = 'CHECKLIST_REDESIGN.SAVING_DRAFT';
    const snapshot = {...this.VehiclesCompleteChecklist, CreatedBy: this.VehiclesCompleteChecklist.CreatedBy || BaseServices.UserId,
      ModifiedBy: BaseServices.UserId, CheckListData: JSON.stringify(this.checkpoints)};
    this.subscriptions.push(this.CompleteCheckListServices.saveVehicleDraft(snapshot).subscribe({
      next: (result: any) => {
        this.VehiclesCompleteChecklist.Id = typeof result === 'number' ? result : result.Id;
        this.draftSaving = false;
        this.draftStatus = version === this.draftVersion ? 'CHECKLIST_REDESIGN.DRAFT_SAVED' : 'CHECKLIST_REDESIGN.UNSAVED';
        if (version !== this.draftVersion) this.draftChanges.next();
      },
      error: () => { this.draftSaving = false; this.draftStatus = 'CHECKLIST_REDESIGN.DRAFT_ERROR'; }
    }));
  }

    constructor(
        private CompleteCheckListServices: CompleteCheckListServices,
        private route: ActivatedRoute,
        private Location: Location,
        private router: Router
    ) { }

    ngOnInit() {
    this.subscriptions.push(this.draftChanges.pipe(debounceTime(1500)).subscribe(() => this.saveDraft()));
        this.VehiclesCompleteChecklisttData = [];
        this.subscriptions.push(this.CompleteCheckListServices.getVehiclesChecklistById(
            this.route.snapshot.params['clId'], this.route.snapshot.params['fkey']
        ).subscribe(result => {
            if (result) {
                this.VehiclesCompleteChecklist = result;
                this.VehiclesCompleteChecklisttData = JSON.parse(
                    this.VehiclesCompleteChecklist.CheckListData
                );
            }
        }));
    }

    setStatus(event: VehiclesCompleteStatus, status: VehiclesCompleteStatus[]) {
        for (let statusitem of status) {
            if (statusitem.Type == event.Type) {
                statusitem.Value = true;
            } else {
                statusitem.Value = false;
            }
        }
    this.queueDraft();
    }


    SaveCompleteCheckList() {
        this.showLoader = true;
        let CultureInfo = sessionStorage.getItem('languageMode');
        this.VehiclesCompleteChecklist.CheckListData = JSON.stringify(
            this.VehiclesCompleteChecklisttData
        );
        this.subscriptions.push(this.CompleteCheckListServices.VehiclesChecklistById(
            this.VehiclesCompleteChecklist
            , CultureInfo
        ).subscribe((result: any) => {
            if (result) {
                this.featureKey = result.FeatureKey;
                this.VehiclesCompleteChecklist = result;
                this.VehiclesCompleteChecklisttData = JSON.parse(
                    this.VehiclesCompleteChecklist.CheckListData
                );
                this.showLoader = false;
                this.Location.back();
            }
        }));
    }

    checkValid() {
        let val = false;
        if (this.VehiclesCompleteChecklisttData) {
            for (let section of this.VehiclesCompleteChecklisttData) {
                let status = section.Status;
                if (
                    status[0].Value === false &&
                    status[1].Value === false &&
                    status[2].Value === false
                ) {
                    val = true;
                }
            }
        }
        return val;
    }
    goBack() {
        this.Location.back();
    }
    ngOnDestroy() {
    this.draftChanges.complete();
        this.subscriptions.forEach((sub, i) => {
            sub.unsubscribe();
        });
    }
}
